<header>
  <h2 style="padding-right: 50px">Consulta Póliza Matrícula MUTUA</h2>
  <span style="flex: 1 1 auto;"></span>
  <!-- Cerrar sin devolver nada -->
  <button id="btnCerrar"
          mat-icon-button
          (click)="onClose()">
    X
  </button>
</header>
<mat-dialog-content style="padding-bottom: 20px;">
  <form [formGroup]="busquedaForm" (ngSubmit)="verificar()">
    <fieldset [disabled]="cargando">
      <label>
        Matrícula<br>
        <input type="text" matInput autofocus formControlName="matricula"><br>
      </label>

      <label>
        Fecha siniestro<br>
        <input type="date" matInput formControlName="fecha"><br>
      </label>
    </fieldset>
    <footer style="width: 20%">
      <button
        name="buscar"
        type="submit"
        style="width: 100%"
        formnovalidate
        mat-flat-button
        class="btnCCOscuro"
        [disabled]="!busquedaForm.valid || cargando">
        Verificar
      </button>
    </footer>
  </form>
  <!-- Loader -->
  <div class="loader-container" *ngIf="cargando">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="50"
      color="primary">
    </mat-progress-spinner>
    <p>Verificando póliza, por favor espere...</p>
  </div>
  <!-- Resultado -->
  <dl *ngIf="resultado && !cargando">
    <div>
      <dt>Resultado</dt>
      <dd>{{ resultado?.result ? 'Cobertura OK' : 'Sin cobertura' }}</dd>
    </div>

    <div *ngIf="resultado?.mensaje">
      <dt>Mensaje</dt>
      <dd>{{ resultado.mensaje }}</dd>
    </div>

    <!-- Mostrar status SOLO si es un error interno (>=500) -->
    <div *ngIf="resultado?.status && resultado?.status >= 500">
      <dt>Status</dt>
      <dd>{{ resultado.status }}</dd>
    </div>
  </dl>
</mat-dialog-content>
<!-- Guardar devolviendo datos -->
<mat-dialog-actions align="center" style="margin-bottom: 20px; margin-top:5px;" *ngIf="resultado && !cargando">
  <button style="width: 30%;"
          type="button"
          class="btnCCNewOscuro"
          mat-flat-button
          (click)="guardar()"
          [disabled]="cargando">
    Grabar en hoja
  </button>
</mat-dialog-actions>
